<template>
  <v-sheet
    class="px-3 pt-6 mx-auto"
    color="transparent"
    max-width="1600px"
    width="100%"
  >
    <div>
      <TitleWidget>{{ title }}</TitleWidget>

      <div
        v-if="!xsOnly"
        class="secundary--text text-subtitle-1 font-weight-regular"
      >
        {{ subtitle }}
      </div>
    </div>

    <DataTableTemplate
      class="mt-4"
      no-data-text="Nenhum link encontrado"
      :height="tableHeight"
      :loading="isLoading"
      :headers="headers"
      :items="links"
    >
      <template v-slot:item.fazenda="{ item }">
        <div class="text-body-2 font-weight-medium text-ellipsis">
          <template v-if="item.fazenda?.id">
            <a
              class="secondary--text text--darken-2 text-decoration-none"
              :href="`/portfolio/${item.fazenda.id}`"
              target="_blank"
            >
              {{
                item.fazenda?.nome
                  ? item.fazenda.nome +
                    (item.fazenda?.area_total
                      ? " • " +
                        formatArea(
                          item.fazenda.sistema_metrico,
                          item.fazenda.area_total,
                        )
                      : "")
                  : ""
              }}

              <v-icon color="secondary darken-2" size="12">
                mdi-open-in-new
              </v-icon>
            </a>
          </template>
        </div>
      </template>

      <template v-slot:item.nome="{ item }">
        <div class="secondary--text">
          {{ nomeTelefone(item) }}
        </div>
      </template>

      <template v-slot:item.expires_at="{ item }">
        <!-- <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              class="d-inline-flex align-center secondary--text"
            >
              <v-sheet
                class="rounded-circle mr-1"
                :color="formatExpireAt(item.expires_at, 'color')"
                height="10px"
                width="10px"
              ></v-sheet>

              {{ formatExpireAt(item.expires_at) }}
            </div>
          </template>

          <span> {{ formatExpireAt(item.expires_at, "tooltip") }}</span>
        </v-tooltip> -->

        <div class="d-inline-flex align-center secondary--text">
          <v-sheet
            class="rounded-circle mr-1"
            color="grey"
            height="10px"
            width="10px"
          ></v-sheet>

          Sem validade
        </div>
      </template>

      <template v-slot:item.user="{ item }">
        <div class="secondary--text">
          {{ item.user ? item.user.username : "Usuário removido" }}
        </div>
      </template>

      <template v-slot:item.created_at="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="d-inline secondary--text">
              {{ formatCreatedAt(item.created_at) }}
            </div>
          </template>

          <span> {{ formatCreatedAt(item.created_at, true) }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.acoes="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              color="blue"
              :href="`/link/${item.token}`"
              target="_blank"
              small
              icon
            >
              <v-icon size="16"> mdi-eye </v-icon>
            </v-btn>
          </template>

          <span>Abrir link</span>
        </v-tooltip>

        <!-- <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              color="#222222"
              :to="`/links/${item.id}`"
              small
              icon
            >
              <v-icon size="16"> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>

          <span>Abrir fazenda</span>
        </v-tooltip> -->

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              @click="toggleDelete(item)"
              :color="item.deleted_at ? 'error' : 'success'"
              small
              icon
            >
              <v-icon size="20">
                {{
                  item.deleted_at
                    ? "mdi-toggle-switch-off-outline"
                    : "mdi-toggle-switch"
                }}
              </v-icon>
            </v-btn>
          </template>

          <span>{{ item.deleted_at ? "Ativar" : "Desativar" }}</span>
        </v-tooltip>
      </template>
    </DataTableTemplate>

    <v-dialog
      v-if="item?.id && dialogDelete"
      v-model="dialogDelete"
      max-width="500"
      persistent
    >
      <DeleteItemDialog
        @confirm="onDelete"
        @close="toggleDelete"
        title="Desativar link"
        :loading="isLoadingDelete"
        name="esse link"
        btn-text="Desativar"
        change-text
      />
    </v-dialog>
  </v-sheet>
</template>

<script>
import TitleWidget from "@/components/widgets/Title.vue";
import DataTableTemplate from "@/components/templates/DataTable.vue";
import DeleteItemDialog from "@/components/dialogs/DeleteItem.vue";
import maskPhone from "@/utils/maskPhone";
import formatArea from "@/utils/formatArea";
import formatCreatedAt from "@/utils/formatCreatedAt";
import formatExpireAt from "@/utils/formatExpireAt";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { TitleWidget, DataTableTemplate, DeleteItemDialog },
  data: () => ({
    title: "Links gerados",
    subtitle: "Gerencie os links disponibilizados",
    isLoading: true,
    links: [],
    page: 1,
    headers: [
      {
        text: "Nome da área",
        align: "start",
        value: "fazenda",
      },
      {
        text: "Para",
        align: "start",
        value: "nome",
      },
      {
        text: "Expira em",
        align: "start",
        value: "expires_at",
      },
      {
        text: "Criado por",
        align: "start",
        value: "user",
      },
      {
        text: "Registro",
        align: "start",
        value: "created_at",
      },
      {
        text: "Ações",
        align: "center",
        sortable: false,
        value: "acoes",
        width: 150,
      },
    ],
    dialogDelete: false,
    item: null,
    isLoadingDelete: false,
  }),
  computed: {
    ...mapGetters("users", ["getUser"]),
    tableHeight() {
      const name = this.$vuetify.breakpoint.name;

      const offset = name === "sm" ? 235 : name === "xs" ? 210 : 244;

      return `calc(100dvh - ${offset}px)`;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    ...mapActions("properties", ["listLinks", "deleteLink"]),
    async onLoad(page = 1, itemsPerPage = 1000) {
      this.page = page;
      this.isLoading = true;

      let filters = {
        page: page,
        itemsPerPage,
      };

      const links = await this.listLinks(filters);
      this.links = links.data;
      this.isLoading = false;
    },
    toggleDelete(item) {
      if (item?.deleted_at) {
        this.item = item;
        this.onDelete("reactivate");
        return;
      }

      if (this.dialogDelete) {
        this.dialogDelete = false;
        this.item = null;
      } else {
        this.item = item;
        this.dialogDelete = true;
      }
    },
    async onDelete(action = "deactivate") {
      this.isLoadingDelete = true;

      const r = await this.deleteLink(this.item.id);
      const message = {
        success: {
          deactivate: {
            text: "Link desativado com sucesso.",
            icon: "mdi-link-variant-remove",
          },
          reactivate: {
            text: "Link reativado com sucesso.",
            icon: "mdi-link-variant-plus",
          },
        },
        error: {
          deactivate: {
            text: "Não foi possível desativar o link. Tente novamente.",
            icon: "mdi-link-variant-off",
          },
          reactivate: {
            text: "Não foi possível reativar o link. Tente novamente.",
            icon: "mdi-link-variant-off",
          },
        },
      };

      const status = r ? "success" : "error";

      this.$eventHub.$emit("snackBar", {
        message: message[status][action].text,
        icon: message[status][action].icon,
        type: status,
      });

      if (r) {
        this.dialogDelete = false;
        this.item = null;

        this.onLoad();
      }

      this.isLoadingDelete = false;
    },
    nomeTelefone(v) {
      return [v.nome, this.maskPhone(v.telefone)].filter(Boolean).join(" • ");
    },
    maskPhone,
    formatArea,
    formatCreatedAt,
    formatExpireAt,
  },
  async mounted() {
    this.onLoad();
  },
};
</script>
